import { Divider } from '@src/common/components/Divider';
import type { ComponentProps } from 'react';

export const HorizontalDivider = (
  props: Partial<ComponentProps<typeof Divider>>,
) => <Divider orientation="horizontal" flexItem {...props} />;
